<template>
    <!-- 弹窗展示数据 -->
    <a-modal 
        :width="props.width" 
        v-model:visible="props.show" 
        centered 
        :title="props.title || '-'" 
        @cancel="cancel" 
    >
        <div class="content_box">
            <div v-if="!state.checkState" style="white-space: pre-line;" v-html="state.data.notice"></div>

            <template v-else>
                <UploadBox 
                    :fileList="state.data.payImages" 
                    @change="uploadChange($event, 'payImages')"
                    :disabled="state.payEditState"
                >
                    <span v-if="!state.payEditState">上传付款成功截图作为凭证，务必清晰可见</span>
                    <span v-else>提交时间：{{state.data.examSignUpTime || "-"}}</span>
                </UploadBox>
            </template>
        </div>
        <template #footer>
            <div class="btn_box" v-if="!state.checkState">
                <a-button style="margin-right: 5px;" @click="cancel">取消</a-button>
                <a-button type="primary" @click="application" :loading="state.loading">我已知晓，立即报名</a-button>
            </div>
            <div class="btn_box" v-else>
                <div class="left">
                    <span v-if="state.data.payCheckEmployeeId">{{state.data.payCheckNoPassMsg}}</span>
                    <span v-else>{{state.data.checkNoPassMsg}}</span>
                </div>
                <a-button style="margin-right: 5px;" v-if="state.cancelText" @click="cancel">取消</a-button>
                <a-button type="primary" @click="handleOk" :loading="state.loading">{{state.okText}}</a-button>
            </div>
        </template>
    </a-modal>
</template>

<script setup>
import { ref, reactive, watch } from "vue"; 
import UploadBox from "@/views/my_page/components/upload_box.vue"; 
import { imgUrlList } from "@/views/my_page/index.js"; 
import { trainSignUp, trainPayUpload } from "@/api/my_page/paper"; 
import { message } from 'ant-design-vue';
const props = defineProps({
    width: {
        type: Number || String,
        default: 750
    }, 
    show: {
        type: Boolean,
        default: false
    }, 
    type: {
        type: [String, Number],
        default: 1
    }, 
    title: {
        type: String,
    }, 
    data: {
        type: Object,
        default: ()=>{
            return {}
        }
    },
})
const emit = defineEmits([ "update:show", "updateList", "okChange", "cancel" ]); 

let state = reactive({
    loading: false, 
    okText: "确定", 
    cancelText: false, // 取消按钮 
    checkState: null, // 审核状态 
    data: {}, 

    payImages: "", // 付费凭证 

    signEditState: true, // 报名禁用 
    payEditState: true, // 缴费禁用 
});
watch(() => props.data, newVal => {
    if (newVal) { 
        // console.log("newVal====", newVal, newVal.checkState);
        state.data = {...newVal}; 
        state.checkState = newVal.checkState; 
        state.data.payImages = imgUrlList(newVal.payImages); 

        // 修改报名禁用状态 
        if (newVal.checkState == 2 || newVal.checkState == 6) {
            state.payEditState = false; 
            state.cancelText = true; 
        }
    }
}, { deep: true })

// 图片上传事件 
function uploadChange(params, key) { 
    // console.log("上传的图片路径", params, key); 
    state[key] = params; 
} 

// 培训报名 
function application() {
    // console.log("state.data", state.data);
    let params = {
        paperStudentMajorId: state.data.paperStudentMajorId,
        trainType: 3, 
    }
    state.loading = true; 
    trainSignUp(params).then((result) => { 
        state.loading = false; 
        cancel(); 
        updateList(); 
    }).catch((err) => { 
        state.loading = false; 
        console.log("err====", err); 
    }); 
}
// 上传付费凭证 
function payVoucher() {
    if (!state.payImages) {
        message.error("请上传付费凭证")
        return 
    }
    let params = {
        paperStudentMajorId: props.data.paperStudentMajorId, 
        payImages: state.payImages, 
        trainType: 3, 
    }; 
    state.loading = true; 
    trainPayUpload(params).then((result) => { 
        state.loading = false; 
        cancel(); 
        updateList(); 
    }).catch((err) => { 
        state.loading = false; 
        console.log("err====", err); 
    }); 
}

function handleOk() {
    // 没有取消按钮 触发关闭 
    if (!state.cancelText) {
        cancel(); 
    } else { 
        if (state.checkState == 2 || state.checkState == 6) {
            payVoucher(); 
        } 
    } 
} 
function init() {
    state.cancelText = false; 
    state.signEditState = true; // 报名禁用 
    state.payEditState = true; // 缴费禁用 
    state.data = {}; 
}
function cancel() {
    emit("update:show", false); 
    setTimeout(() => {
        init()
    }, 100);
}
function updateList() {
    emit("updateList"); 
}

</script>

<style lang="less" scoped>
.content_box {
    width: 100%;
    min-height: 200px;
    max-height: 60vh;
    overflow: auto;
    .data_box {
        padding-bottom: 10px;
        .txt_box {
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            .s1 {
                width: max-content;
            }
        }
    }
    .title {
        margin-top: 20px;
        font-weight: 600;
    }
    .btn_box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left {
            flex: 1;
            color: #ffa500;
        }
    }
}

</style>